export const COVER_AND_CARE_SCHOOL_ID = 'a9142e60-39a5-11ed-a364-73e57bae870f'

export const usesCoverAndCare = id => id === COVER_AND_CARE_SCHOOL_ID

// SAI needs both records in storage before its first render.
export const prepareSchoolLanding = async (axios, { user, schools, token }) => {
  if (!usesCoverAndCare(schools?.[0]?.id) || user?.sai !== 1) return '/dashboard'

  const response = await axios.post('v1/staff-hub/policy', {
    token,
    orgId: schools[0].id,
    user: user.contact_id,
  }, { headers: { Authorization: `Bearer ${token}` } }).catch(() => null)
  // Let the existing dashboard handle policy-loading failures without failing login.
  if (!response) return '/dashboard'
  const data = response.data.result?.data
  const policy = data?.policies?.sai
  const org = data?.org
  if (response.data.error === true || !policy?.department || !policy?.policy_id || !org) {
    return '/dashboard'
  }
  const organisation = org.trust_name
    ? { type: 'trust', postcode: org.trust_postcode, name: org.trust_name, id: org.trust_id }
    : { type: 'academy', postcode: org.academy_postcode, name: org.academy_name, id: org.academy_id }
  if (!usesCoverAndCare(organisation.id)) return '/dashboard'

  localStorage.setItem('orgType', JSON.stringify(organisation))
  localStorage.setItem('policyData', JSON.stringify(policy))
  localStorage.removeItem('currentPolicy')
  return '/sai/dashboard'
}
